import { createI18n } from 'vue-i18n'
import zhLocale from '@/i18n/locales/zh.json'
import enLocale from '@/i18n/locales/en.json'

// 导入语言文件
const messages = {
  zh: { ...zhLocale },
  en: { ...enLocale }
}

// 安全获取 localStorage
function getLocale() {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('locale') || 'en'
    }
  } catch (e) {
    console.error('访问 localStorage 失败:', e)
  }
  return 'en' // 默认语言
}

// 创建i18n实例
const i18n = createI18n({
  legacy: false, // 使用组合式API
  locale: getLocale(), // 使用安全的方法获取语言设置
  fallbackLocale: 'en', // 设置回退语言
  globalInjection: true, // 全局注入 $t 方法
  messages: messages,
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  silentFallbackWarn: process.env.NODE_ENV === 'production'
})

export default i18n
